import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component"
import { PurchaseOrderManySchema, PurchaseOrderManyType } from "@/routes/(pharma)/_layout/reports/purchase-order-list/-data/type";
import { PurchaseOrderParams } from "@/routes/(pharma)/_layout/reports/purchase-order-list/-data/model";
import { Loading } from "@/layouts/loading";
import { PurchaseOrder } from "@/gen/purchase_order/common_pb";
import { pharmacyClient } from "@/connect";

type Props = {
    purchaseOrders: PurchaseOrder[];
    totalCount: number;
}
export const Route = createFileRoute("/(pharma)/_layout/reports/purchase-order-list/")({
    component: Component,
    validateSearch: PurchaseOrderParams,
})